import { Stack, Typography } from "@mui/material";

import { TagNew } from "@/modules/irohana-components/elements/TagNew";
import { background, blue, text } from "@/modules/irohana-components/theme/colors";
import { FCC } from "@/modules/irohana-components/types/common";

export type TNotificationProps = {
  title: string;
  tag: string;
};

export const Notification: FCC<TNotificationProps> = ({ title, tag, children }) => {
  return (
    <Stack p={3} gap={3} bgcolor={background.white}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="sub16Semi">{title}</Typography>
        <TagNew color={blue[60]} variant="regular" title={tag} textColor={text.white} sx={{ color: text.white }} />
      </Stack>
      {children}
    </Stack>
  );
};
